import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { Constants } from '../models/constants';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptor implements HttpInterceptor {

  constructor(private router: Router, private authService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authenticationKey = localStorage.getItem(Constants.AuthtokenKey);
    if (!authenticationKey) {
      request = request.clone({
        setHeaders: {
          "X-API-KEY": environment.baseApiKey
        }
      });
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: {
        Authorization: `${authenticationKey}`,
        "X-API-KEY": environment.baseApiKey
      }
    });

    return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
  }

  handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      //navigate /delete cookies or whatever
      this.authService.clearAuthenticationToken();
      this.router.navigateByUrl(`/signin`);
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message); // or EMPTY may be appropriate here
    }
    return throwError(err);
  }
}
